import { Component, ElementRef, EventEmitter, Input, Output, computed, inject, signal } from '@angular/core';
import { ThemeService } from '@services/theme.service';
import { editor } from 'monaco-editor';
import IStandaloneEditorConstructionOptions = editor.IStandaloneEditorConstructionOptions;

@Component({
  selector: 'code-area',
  templateUrl: './code-area.component.html',
  standalone: false,
})
export class CodeAreaComponent {
  private readonly themeService = inject(ThemeService);
  private readonly userOptions = signal<IStandaloneEditorConstructionOptions>({});

  constructor() {
    // Exposes the component instance on the host element (used by e2e tests to reach into the component).
    (inject(ElementRef).nativeElement as { component?: CodeAreaComponent }).component = this;
  }
  readonly codeOptions = computed<IStandaloneEditorConstructionOptions>(() => ({
    language: 'json',
    minimap: { enabled: false },
    scrollbar: { alwaysConsumeMouseWheel: false },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    theme: this.themeService.theme() === 'dark' ? 'vs-dark' : 'vs',
    ...this.userOptions(),
  }));

  model = '{}';
  @Input() modelType: 'json' | 'string' = 'json';
  @Input() cssClass: string | string[] | Record<string, any> = {};
  @Input() cssStyle: Record<string, any> = {};
  @Output() valueChange = new EventEmitter<object | string | null>();

  get value() {
    let value: object | string | null = this.model;
    if (this.modelType === 'json') {
      try {
        value = JSON.parse(this.model);
      } catch (error) {
        value = this.model;
      }
    }
    return value;
  }

  @Input()
  set value(value: object | string | null) {
    if (typeof value === 'object') {
      this.model = JSON.stringify(value, null, 2);
    } else {
      this.model = value;
    }
  }

  @Input()
  set options(value: IStandaloneEditorConstructionOptions) {
    this.userOptions.set(value);
  }

  modelChange() {
    this.valueChange.emit(this.value);
  }
}
